import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { ReactComponent as DownIcon } from "../../assets/icons/table/down.svg";
import { ReactComponent as UpIcon } from "../../assets/icons/table/up.svg";
import { ICategory } from "../../types/category.type";
import styles from "./styles.module.scss";

interface Props {
  categories: ICategory[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: ICategory) => void;
  onClickRow?: (index: number, direction: "up" | "down") => void;
  allCategories?: ICategory[];
}

const CategoriesTable: React.FC<Props> = (props) => {
  const getDisabledState = (category: ICategory, direction: "up" | "down") => {
    if (!props.onClickRow || !props.allCategories || props.allCategories.length === 0) {
      return false;
    }

    // Знаходимо позицію категорії в повному списку
    const categoryIndex = props.allCategories.findIndex((cat) => cat.id === category.id);

    if (categoryIndex === -1) {
      return true; // Якщо категорію не знайдено, вимикаємо кнопки
    }

    if (direction === "up") {
      return categoryIndex === 0;
    } else {
      return categoryIndex === props.allCategories.length - 1;
    }
  };

  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          {props.onClickRow && <th></th>}
          <th>Категорія</th>
          <th>Фотографія</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.categories &&
          props.categories.map((user, index) => (
            <tr key={user.id}>
              {props.onClickRow && (
                <td>
                  <div className={styles.controllerContainer}>
                    <button
                      className={styles.controllerButton}
                      onClick={() => props.onClickRow!(index, "up")}
                      disabled={getDisabledState(user, "up")}
                    >
                      <UpIcon className={styles.controllerIcon} />
                    </button>
                    <button
                      className={styles.controllerButton}
                      onClick={() => props.onClickRow!(index, "down")}
                      disabled={getDisabledState(user, "down")}
                    >
                      <DownIcon className={styles.controllerIcon} />
                    </button>
                  </div>
                </td>
              )}
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.nameContainer}>
                    <span className={styles.name}>{user.name}</span>
                  </div>
                </div>
              </td>

              <td className={styles.role}>
                <img
                  src={user.imageUrl}
                  className={styles.bigPhoto}
                  alt="category"
                />
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    className={styles.editBtn}
                    onClick={() => {
                      props.callBackInfo(false);
                      props.callBackEdit(user);
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    className={styles.infoBtn}
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(user);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default CategoriesTable;
